// src/redux/projectsSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchProjectsThunk, submitProjectsThunk, fetchEventDetailsThunk, fetchSpeechThunk, fetchActivitiesThunk, fetchProjectsForEventThunk }
  from "./fetchProjectsThunk";

const projectsSlice = createSlice({
  name: "projects",
  initialState: {
    data: [],
    loading: false,
    error: null,
    eventDetails: {
      awareness: {
        faqs: [],
        projects: [],
        speeches: { staticSpeeches: { shortSpeech: [], longSpeech: [] }, aiPrompts: [] },
        activities: { list: [], loading: false, error: null },
        loading: false,
        error: null
      },
      celebration: {
        faqs: [],
        projects: [],
        speeches: { staticSpeeches: { shortSpeech: [], longSpeech: [] }, aiPrompts: [] },
        activities: { list: [], loading: false, error: null },
        loading: false,
        error: null
      }
    }
  },
  reducers: {
    clearProjects: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
    },
    clearEventDetails: (state, action) => {
      const category = action.payload === 1 ? "awareness" : "celebration";
      state.eventDetails[category] = {
        faqs: [],
        speeches: { staticSpeeches: { shortSpeech: [], longSpeech: [] }, aiPrompts: [] },
        loading: false,
        error: null
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProjectsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(submitProjectsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitProjectsThunk.fulfilled, (state, action) => {
        state.loading = false;
        console.log("Submitted successfully:", action.payload);
      })
      .addCase(submitProjectsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchEventDetailsThunk.pending, (state, action) => {
        const category = action.meta.arg.category_id === 1 ? "awareness" : "celebration";
        state.eventDetails[category].loading = true;
        state.eventDetails[category].error = null;
      })
      .addCase(fetchEventDetailsThunk.fulfilled, (state, action) => {
        const category = action.payload.category_id === 1 ? "awareness" : "celebration";
        state.eventDetails[category].loading = false;
        state.eventDetails[category].faqs = action.payload.data?.faqs || [];
      })
      .addCase(fetchEventDetailsThunk.rejected, (state, action) => {
        const category = action.meta.arg.category_id === 1 ? "awareness" : "celebration";
        state.eventDetails[category].loading = false;
        state.eventDetails[category].error = action.payload;
      })

      // ✅ Handle speeches
      .addCase(fetchSpeechThunk.pending, (state, action) => {
        const key = action.meta.arg.category_id === 1 ? "awareness" : "celebration";
        state.eventDetails[key].loading = true;
        state.eventDetails[key].error = null;
      })
      .addCase(fetchSpeechThunk.fulfilled, (state, action) => {
        const key = action.payload.category_id === 1 ? "awareness" : "celebration";
        const speechesData = action.payload.data.speeches;
        const staticSpeeches = { shortSpeech: [], longSpeech: [] };
        const aiPrompts = [];
        speechesData.forEach((s) => {
          const title = s.speech_title || "Untitled Speech"; // ✅ Use speech_title from API
          const content = s.speech;

          if (s.speech_type === 0) {
            staticSpeeches.shortSpeech.push({
              title,
              content,
            });
          } else if (s.speech_type === 1) {
            staticSpeeches.longSpeech.push({
              title,
              content,
            });
          } else if (s.speech_type === 2) {
            if (!aiPrompts.includes(content)) {
              aiPrompts.push(content);
            }
          }
        });
        state.eventDetails[key].speeches = { staticSpeeches, aiPrompts };
        state.eventDetails[key].loading = false;
      })
      .addCase(fetchSpeechThunk.rejected, (state, action) => {
        const key = action.meta.arg.category_id === 1 ? "awareness" : "celebration";
        state.eventDetails[key].loading = false;
        state.eventDetails[key].error = action.payload;
      })
      .addCase(fetchActivitiesThunk.pending, (state, action) => {
        const key = action.meta.arg.category_id === 1 ? "awareness" : "celebration";
        state.eventDetails[key].activities = { list: [], loading: true, error: null };
      })
      .addCase(fetchActivitiesThunk.fulfilled, (state, action) => {
        const key = action.payload.category_id === 1 ? "awareness" : "celebration";
        state.eventDetails[key].activities = {
          list: action.payload.data.activities,
          loading: false,
          error: null,
        };
      })
      .addCase(fetchActivitiesThunk.rejected, (state, action) => {
        const key = action.meta.arg.category_id === 1 ? "awareness" : "celebration";
        state.eventDetails[key].activities = {
          list: [],
          loading: false,
          error: action.payload,
        };
      })
      .addCase(fetchProjectsForEventThunk.fulfilled, (state, action) => {
        const key = action.payload.category_id === 1 ? "awareness" : "celebration";
        state.eventDetails[key].projects = action.payload.data;
      });
  }
});

export const { clearProjects, clearEventDetails } = projectsSlice.actions;
export default projectsSlice.reducer;
